import { Box } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/_auth')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundImage: `
            url('/Pattern.png'),
            linear-gradient(180deg, #8DF4C4 0%, #73D7E0 60%, #ffffff 100%)`,
        backgroundSize: 'cover, cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '24px'
      }}
    >
      <Outlet />
    </Box>
  );
}
